export const uiPathLogo = 'https://staticresourcescp.blob.core.windows.net/auth0-spa/UiPath-full-logo.svg';
